// import React from "react";
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const imagePaths = ["/services3.jpg", "/services2.jpg", "/services1.jpg"];

const Services = () => {
  return (
    <Box sx={{ width: "100%", textAlign: "center", }}>

      {/* Image Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: { xs: "10px", md: "5px" },
          flexWrap: "wrap",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          backgroundColor: "#F5F5F5",
          paddingBottom: "5rem"
          // width: "100%"
        }}
      >
        {imagePaths.map((image, index) => (
          <Box
            key={index}
            component="img"
            src={image}
            alt={`Service ${index + 1}`}
            sx={{
              width: { xs: "100%", md: "33.1%" }, 
              height: { xs: "auto", md: "600px" }, 
              objectFit: "cover", // Ensures consistent size by cropping the image
              borderRadius: "0px",
              padding: { xs: "0px", md: "0px" },
            }}
          />
        ))}
      </Box>

      {/* Grey Text Box with Accordions */}
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#F5F5F5",
          color: "black",
          // paddingTop: "rem",
          paddingBottom: "3rem",
          border: 'none'
        }}
      >
        {/* Accordion Section */}
        {[
          {
            title: "Remodels/Renovations",
            content:
              "Whether it’s a major renovation or re-imagining your kitchen and bathroom, we focus on enhancing the existing structure while honoring its original character. We start by creating an existing floor plan of your space and then work through a multitude of design layout ideas until a final design layout is created. Once the layout is finalized, we move on to selecting architectural materials, finishes, and fixtures. We will handle everything from cabinetry design, built-in designs, elevations, 3-D renderings, and electrical plans to ensure a unified design is created and that you are supported throughout the entire remodeling process.",
          },
          {
            title: "Design Day",
            content:
              "We love being involved in our projects from the initial concept all the way through to final installation. However, we recognize that not all clients require the full-service approach. Some may just need help with the finishing touches of a few spaces while others may prefer to take a more hands-on role in the process. To cater to these needs, we developed our Design Day service. This offering provides clients with a detailed, high-quality design plan that clients can confidently execute at their own pace according to their schedule and budget. Design Day is ideal for designing a single room or selecting a few key pieces for different spaces. This service offers flexibility and expert guidance without the full commitment.",
          },
          {
            title: "Furnishings",
            content:
              "We provide comprehensive furnishing, accessorizing, and styling services tailored to your needs. The process starts with an in-person consultation to understand your goals and preferences. Once we've defined the desired design aesthetic, we handle sourcing all the furniture, décor, lighting, accessories, and window treatments. Our white-glove service ensures everything is delivered and installed on the scheduled day. From coordinating delivery to styling and final touches, we manage every detail for a seamless, turn-key experience.",
          },
          {
            title: "Consultations",
            content:
              "There are times when all you need is a little guidance to get things moving in the right direction. An in-home consultation is a 2-hour session where we can help with selecting paint colors, review material selections for a remodel or new build, conceptual space planning, choosing furniture, etc. You’ll have the freedom to decide what you’d like to focus on during our time together so you can feel confident about your design.",
          },
        ].map((item, index) => (
          <Accordion
            key={index}
            sx={{
              background: "#F5F5F5",
              border:'none',
              // boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              // borderRadius: "8px",
              "&:last-child": { marginBottom: 0 },
              "&:before": { display: "none" }, // Removes default MUI outline
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#333" }} />}
              sx={{
                background: "#e6e4df",
                // borderRadius: "8px",
                padding: { xs: "1rem", sm: "1.2rem" },
                "&:hover": { backgroundColor: "#d6d4cf" },
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontSize: { xs: "1.3rem", sm: "1.5rem", md: "1.7rem" },
                  fontWeight: 600,
                  color: "#333",
                  transition: "color 0.3s ease-in-out",
                  "&:hover": { color: "#000" },
                }}
              >
                {item.title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                padding: { xs: "1rem", sm: "2rem", md: "2.5rem" },
                background: "#F5F5F5",
                borderRadius: "8px",
                transition: "all 0.3s ease-in-out",
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "1rem", sm: "1.2rem", md: "1.4rem" },
                  textAlign: "left",
                  lineHeight: { xs: 1.5, sm: 1.7, md: 1.8 },
                  color: "#444",
                }}
              >
                {item.content}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>


    </Box>
  );
};

export default Services;
